import { IOperationAllow, canOperate } from '../common';
import { filter as lfilter } from 'lodash/fp';
import { concatAll } from 'fp-ts/lib/Monoid';
import { MonoidAny } from 'fp-ts/lib/boolean';

export const labels = (operations: IOperationAllow[], operationsPage?: boolean) =>
  operationsPage ?
    lfilter<{ label: string; value: number; allow: boolean }>({ allow: true })([
      (import.meta.env.VITE_ACCOUNT_ACTIVATION_FEATURE === 'ENABLED' && {
        label: 'Account Activation',
        value: 0,
        allow: concatAll(MonoidAny)([
          canOperate(operations)('helpDesk'),
          canOperate(operations)('operations'),
        ]),
      }),
      (import.meta.env.VITE_ACCOUNT_ACTIVATION_FEATURE === 'ENABLED' && {
        label: 'Password Reset',
        value: 1,
        allow: concatAll(MonoidAny)([
          canOperate(operations)('helpDesk'),
          canOperate(operations)('operations'),
        ]),
      }),
    ]) :
    lfilter<{ label: string; value: number; allow: boolean }>({ allow: true })([
      {
        label: 'Search Certificates',
        value: 0,
        allow: concatAll(MonoidAny)([
          canOperate(operations)('helpDesk'),
          canOperate(operations)('rps'),
        ]),
      },
      {
        label: 'Status of Certificates',
        value: 1,
        allow: concatAll(MonoidAny)([
          canOperate(operations)('helpDesk'),
          canOperate(operations)('rps'),
        ]),
      },
      // (import.meta.env.VITE_ACCOUNT_ACTIVATION_FEATURE === 'ENABLED' && {
      //   label: 'Account Activation',
      //   value: 2,
      //   allow: concatAll(MonoidAny)([
      //     canOperate(operations)('helpDesk'),
      //     canOperate(operations)('operations'),
      //   ]),
      // }),
      // (import.meta.env.VITE_ACCOUNT_ACTIVATION_FEATURE === 'ENABLED' && {
      //   label: 'Send Password Reset Email',
      //   value: 3,
      //   allow: concatAll(MonoidAny)([
      //     canOperate(operations)('helpDesk'),
      //     canOperate(operations)('operations'),
      //   ]),
      // }),
    ]);
